// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2Vr0t","infoBtn":"quickbooks_infoBtn__4qIjP","formBox":"quickbooks_formBox__3iR2w","formFooter":"quickbooks_formFooter__1QvLE"};